export const iOSDevice = () => navigator.platform.match(/iPhone|iPod|iPad/u);

export const isDesktopMedia = () => window.matchMedia('(min-width: 979px)').matches;

export const isNewDesktopMedia = () => window.matchMedia('(min-width: 1021px)').matches;

export const isDesktop = () => isDesktopMedia();

export const isNewDesktop = () => isNewDesktopMedia();
